// See https://developers.google.com/maps/documentation/javascript/styling for examples of styling.
// See https://developers.google.com/maps/documentation/javascript/style-reference for element types reference

export const lightStylesWithDetails = [
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#e7e5df'
      }
    ]
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#e7e5df'
      }
    ]
  },
  {
    featureType: 'landscape.natural.landcover',
    elementType: 'geometry',
    stylers: [
      {
        color: '#76AA99'
      }
    ]
  },
  {
    featureType: 'poi',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#76AA99'
      }
    ]
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#f3f3f3'
      }
    ]
  },
  {
    featureType: 'transit',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#9BD1E9'
      }
    ]
  }
];

export const darkStylesWithDetails = [
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#000000'
      }
    ]
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#000000'
      }
    ]
  },
  {
    featureType: 'landscape.natural.landcover',
    elementType: 'geometry',
    stylers: [
      {
        color: '#76AA99'
      }
    ]
  },
  {
    featureType: 'poi',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#76AA99'
      }
    ]
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#6C6C6C'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#6C6C6C'
      }
    ]
  },
  {
    featureType: 'transit',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#8BBACFB2'
      }
    ]
  },
  // Text colors
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#f3f3f3'
      }
    ]
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#212121'
      }
    ]
  },
  {
    featureType: 'administrative.country',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#f3f3f3'
      }
    ]
  },
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#f3f3f3'
      }
    ]
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#f3f3f3'
      }
    ]
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#f3f3f3'
      }
    ]
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#1b1b1b'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#f3f3f3'
      }
    ]
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#f3f3f3'
      }
    ]
  },
  {
    featureType: 'transit',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#f3f3f3'
      }
    ]
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#f3f3f3'
      }
    ]
  }
];

export const minimalStyles = [
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#e7e5df'
      }
    ]
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#e7e5df'
      }
    ]
  },
  {
    featureType: 'landscape.natural.landcover',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e7e5df'
      }
    ]
  },
  {
    featureType: 'landscape.natural.terrain',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e7e5df'
      }
    ]
  },
  {
    featureType: 'poi',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#e7e5df'
      }
    ]
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#e7e5df'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#e7e5df'
      }
    ]
  },
  {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'transit',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#9BD1E9'
      }
    ]
  }
];

/* export const lightStylesWithDetails = [
  {
    id: 'infrastructure',
    geometry: {
      fillOpacity: 1,
      fillColor: '#f3f3f3',
      strokeOpacity: 1,
      strokeColor: '#f3f3f3'
    }
  },
  {
    id: 'infrastructure.building',
    geometry: {
      fillOpacity: 1,
      fillColor: '#e7e5df',
      strokeOpacity: 1,
      strokeColor: '#e7e5df'
    }
  },
  {
    id: 'infrastructure.roadNetwork',
    geometry: {
      fillOpacity: 1,
      fillColor: '#f3f3f3'
    }
  },
  {
    id: 'infrastructure.urbanArea',
    geometry: {
      fillOpacity: 1,
      fillColor: '#e7e5df'
    }
  },
  {
    id: 'landscape.natural.landcover',
    geometry: {
      fillOpacity: 0.60000002,
      fillColor: '#2a836b'
    }
  },
  {
    id: 'natural.land.landCover.dryCrops',
    geometry: {
      fillOpacity: 0.60000002,
      fillColor: '#2a836b'
    }
  },
  {
    id: 'natural.land.landCover.forest',
    geometry: {
      fillOpacity: 0.60000002,
      fillColor: '#2a836b'
    }
  },
  {
    id: 'water',
    geometry: {
      fillOpacity: 1,
      fillColor: '#9bd1e9'
    }
  },
  {
    id: 'poi',
    label: {
      visible: true
    }
  },
  {
    id: 'pointOfInterest.other.cemetery',
    geometry: {
      fillOpacity: 0.60000002,
      fillColor: '#2a836b'
    },
    label: {
      textFillOpacity: 1,
      textFillColor: '#262626'
    }
  },
  {
    id: 'poi.park',
    geometry: {
      fillOpacity: 0.60000002,
      fillColor: '#2a836b'
    },
    label: {
      textFillOpacity: 1,
      textFillColor: '#262626'
    }
  }
]; */

export default {
  gestureHandling: 'cooperative'
};
